import styled from 'styled-components';

export const ExperimentsListWrapper = styled.div`
  display: grid;
  grid-gap: 0.5rem;
  padding: 0.5rem 1rem;
`;

export const ExperimentsListGrid = styled.div`
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  min-width: 250px;
  align-items: flex-start;
  background-color: ${p => p.theme.colors.base100};
  border-radius: 0.5rem;
`;

export const ExperimentSelectWrapper = styled.div`
  display: grid;
  grid-gap: 0.5rem;
  grid-auto-flow: column;
`;
